import Translate from '~/client/shared/i18n/Translate';
import useAppContext from '~/shared/context/AppContext/useAppContext';
import WDTickerBackground from './WDTickerBackground';
import AnimatedNumber from '../AnimatedNumber';
import ParticlesAnimation from '../ParticlesAnimation';

type Props = {
  time: string;
  value: number;
  textSize: string;
  onClick: () => void;
  animate?: boolean;
};

const StatCard: FC<Props> = ({
  time,
  value,
  textSize,
  onClick,
  animate = false,
}) => {
  const { colorScheme } = useAppContext();
  return (
    <div className="relative">
      {animate && <ParticlesAnimation />}

      <div
        className="rounded-xl p-5 bg-goku relative border border-beerus overflow-hidden shadow-sm"
        onClick={onClick}
      >
        <div className="absolute inset-0 z-0 left-[7rem]">
          <WDTickerBackground
            circleColor={colorScheme === 'light' ? '#FFEBE0' : '#473228'}
          />
        </div>
        <div className="flex justify-between">
          <div className="flex flex-col space-y-1">
            <div className="text-sm font-semibold text-bulma">
              <Translate id={time} />
            </div>
            <div className="text-xs font-normal text-bulma whitespace-nowrap">
              USDT • Tether
            </div>
          </div>
          <AnimatedNumber
            className={`leading-none ${textSize}`}
            value={value}
          />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
